var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[(_vm.empAttend)?_c('attend-details',{attrs:{"dates":_vm.filterBy,"empAttend":_vm.empAttend}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }